import { render, staticRenderFns } from "./AnswerMatrix.vue?vue&type=template&id=14cebff1&scoped=true&"
import script from "./AnswerMatrix.vue?vue&type=script&lang=js&"
export * from "./AnswerMatrix.vue?vue&type=script&lang=js&"
import style0 from "./AnswerMatrix.vue?vue&type=style&index=0&id=14cebff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cebff1",
  null
  
)

export default component.exports